export default __webpack_public_path__ + "static/media/110.5cd23a8e.gif";